export default __webpack_public_path__ + "static/media/mobile-phone.6b23f762.png";